import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalPlanRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/plan",
  component: lazyRouteComponent(() => import("./plan.page.js"), "PortalPlan"),
});
